import { Component, Output, Input, EventEmitter, OnInit } from '@angular/core';
import { TestResult } from 'src/app/shared/model/poll.model';

@Component({
  selector: 'app-warning-confirmation-popup',
  templateUrl: 'warning-confirmation-popup.component.html',
  styleUrls: ['./warning-confirmation-popup.component.less', '../../shared/common.less'],
})
export class WarningConfirmationPopupComponent implements OnInit {
  @Input() isMobile: boolean = false;
  @Input() isTestModeActive: boolean = false;
  @Input() testDisplayedCandidates: Array<TestResult> = [];
  @Input() electionTitle: string = '';
  @Input() listName: any;
  @Input() listImage: string = '';
  @Input() sha: string = '';
  @Output() voteConfirmation = new EventEmitter<boolean>();
  @Output() endDetailsPopup = new EventEmitter<boolean>();


  isPhoneValid = false;
  status: number;

  confirmVote(confirm: boolean) {
    this.voteConfirmation.emit(confirm);
  }

  clicAction($event) {
    if (
      $event.target.className === 'div-arriere-plan-action' ||
      $event.target.className === 'div-global-action'
    ) {
      this.confirmVote(false);
    }
  }

  cancelDetails(value) {
    this.endDetailsPopup.emit(value);
  }

  ngOnInit() {
  }
}
